import { useState, type MouseEvent } from 'react';

import { Button, Menu, MenuItem } from '@mui/material';
import { FolderPlus, Upload } from 'lucide-react';

interface IAddNewMenuProps {
  onChange: (context: 'file' | 'directory') => void;
}

const AddNewMenu = ({ onChange }: IAddNewMenuProps) => {
  const [anchor, setAnchor] = useState<HTMLButtonElement>();
  const [open, setOpen] = useState(false);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchor(e.currentTarget);
    setOpen(true);
  };

  return (
    <>
      <Menu
        id="directory-file-add-menu"
        anchorEl={anchor}
        open={open}
        onClose={() => setOpen(false)}
        MenuListProps={{
          'aria-labelledby': 'add-new-menu-button',
        }}
      >
        <MenuItem onClick={() => onChange('file')}>
          <Upload size={16} style={{ marginRight: 8 }} /> Upload files
        </MenuItem>
        <MenuItem onClick={() => onChange('directory')}>
          <FolderPlus size={16} style={{ marginRight: 8 }} /> New directory
        </MenuItem>
      </Menu>
      <Button
        size="small"
        onClick={handleClick}
        id="add-new-menu-button"
        variant="contained"
      >
        Add files
      </Button>
    </>
  );
};

export default AddNewMenu;
